module.exports = __webpack_public_path__ + "img/未标题-3-04.e43f0c50.png";